import React from "react";
import { Tag } from "antd";
import { FASES_LABEL, FASES_COLOR_SUAVE } from "./fasesSoporte";

const NEUTRO = { bg: "#fafafa", border: "#d9d9d9", text: "#595959" };

/**
 * Etiqueta de la fase de un ticket, con esquinas redondeadas. Se usa en los
 * modales de detalle, el tablero, la bandeja de soporte y el drawer del chat
 * para que la etiqueta se vea igual en todo el módulo.
 *
 */
const TagFase = ({ fase, style }) => {
  const c = FASES_COLOR_SUAVE[fase] || NEUTRO;
  return (
    <Tag
      style={{
        backgroundColor: c.bg,
        borderColor: c.border,
        color: c.text,
        borderRadius: 12,
        padding: "0 10px",
        marginRight: 0,
        ...style,
      }}
    >
      {FASES_LABEL[fase] || fase}
    </Tag>
  );
};

export default TagFase;
